import { isToken, walkTokens } from "@sail/engine";
import { tokens as $ } from "../deprecated";
const tokens = {
  $instances: {}
};
walkTokens($, (value, path) => {
  if (isToken(value)) {
    // walkTokens() passes the path as a string, so we need to cast it to a
    // sample token key to satisfy the type checker.
    const tokenPath = path;
    const tokenValue = value;
    const unwrappedTokenValue = "$default" in tokenValue ? tokenValue.$default : tokenValue;
    // @ts-expect-error - $instances is read-only.
    tokens.$instances[tokenPath] = unwrappedTokenValue;
    // @ts-expect-error - tokens is read-only.
    tokens[tokenPath] = unwrappedTokenValue.toString();
  }
});
export { tokens };